export const DASHBOARD_CONTAINERS = {
  KEY_PERFORMING_INDICATORS: "Key Performing Indicators",
  PAYMENTS_PERFORMANCE_PER_MID: "Payin Performance per MID",
  MERCHANTS_WITH_NO_ACTIVITY: "Merchants with NO Activity",
  PAYOUTS_PERFORMANCE_PER_MID: "Payouts Performance per MID",
  PAYOUT_BALANCES: "Payout Balances",
  PAYOUT_ALERTS: "Payout Alerts",
  PAYMENTS_VOLUME_PER_MID: "Payin Volume per MID",
  PENDING_SETTLEMENT_REQUESTS: "Pending Settlement Requests",
  PENDING_OTC_SETTLEMENT_REQUESTS: "Pending OTC Settlement Requests",
  PENDING_WITHDRAWAL_REQUESTS: "Pending Withdrawal Requests",
  PAYOUT_TOP_UP_REQUEST: "Pending Top Up Wallet Requests",
  PAYMENTS_PER_COUNTRY: "Payin per Country",
  PAYOUTS_PER_COUNTRY: "Payouts per Country",
  PAYMENTS: "Payments",
  PAYOUTS: "Payouts",
  PAYMENTS_PER_METHOD: "Payin per Method",
  TOTAL_USD_AVERAGES: "Total USD Averages"
};
